<template>
  <a-form-item
    class="form-full-name-field stc-ant-field-skin"
    label="ФИО"
    name="fullName"
    required
  >
    <a-input
      class="form-full-name-field__input"
      :value="modelValue"
      placeholder="Введите ваше полное имя"
      @update:value="emit('update:modelValue', $event)"
    />
  </a-form-item>
</template>

<script lang="ts" setup>

defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>
